import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link } from '@remix-run/react';

import Typography from '~/components/Typography';
import useTypedLoaderData from '~/hooks/useUtils/useTypedLoaderData';
import type { HomePageLoaderData } from '~/routes';

interface Props {
  text: string;
  children: React.ReactNode;
  viewMoreLink?: string;
  textColor?: any;
  fontFamily?: any;
  isNewWebBuilder?: boolean;
}

const SectionChild = ({ text, viewMoreLink, isNewWebBuilder, accentColor, font }: any) => {
  return (
    <>
      <div className="flex w-full items-center justify-between">
        <Typography as="h6" size="sm" className="font-semibold" color={accentColor} fontFamily={font}>
          {text}
        </Typography>
        {viewMoreLink && !isNewWebBuilder && (
          <Link to={viewMoreLink} prefetch="intent">
            <div className="flex items-center opacity-70 hover:opacity-100">
              <ChevronRightIcon
                style={{
                  color: accentColor,
                }}
                className="h-4 w-4 text-gray-400"
              />
            </div>
          </Link>
        )}
      </div>
    </>
  );
};

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const Section = ({ text, children, viewMoreLink, isNewWebBuilder }: Props) => {
  const { homePage } = useTypedLoaderData<HomePageLoaderData>();
  const accentColor = homePage?.general_section?.theme?.accent_color;
  const font = homePage?.general_section?.theme?.font;

  return (
    <div
      style={{
        borderColor: homePage.general_section?.theme?.border_color,
      }}
      className="mb-6 space-y-3 border-b pb-6"
    >
      <SectionChild
        text={text}
        viewMoreLink={viewMoreLink}
        isNewWebBuilder={false}
        accentColor={accentColor}
        font={font}
      />
      <div>{children}</div>
    </div>
  );
};

export default Section;
